module.exports = __webpack_public_path__ + "static/media/gem4.b28f282b.png";